/** @format */

import React from 'react';
import Cards from './Cards';

const Allcards = () => {
  return (
    <div
      style={{
        marginTop: '30px',
      }}>
      <Cards />
    </div>
  );
};

export default Allcards;
